function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  transform: "rotate(-90 12 12)",
  fill: "#EF6969"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0844 8.81163C16.2518 8.64426 16.2518 8.37291 16.0844 8.20554C15.9171 8.03817 15.6457 8.03817 15.4784 8.20554L11.9992 11.6847L8.52022 8.20574C8.35285 8.03838 8.0815 8.03838 7.91413 8.20574C7.74676 8.37311 7.74676 8.64447 7.91413 8.81183L11.3931 12.2908L8.20525 15.4786C8.03789 15.646 8.03789 15.9174 8.20525 16.0847C8.37262 16.2521 8.64398 16.2521 8.81135 16.0847L11.9992 12.8969L15.1872 16.0849C15.3546 16.2523 15.626 16.2523 15.7933 16.0849C15.9607 15.9176 15.9607 15.6462 15.7933 15.4788L12.6053 12.2908L16.0844 8.81163Z",
  fill: "white"
});

var SvgDeleteFill = function SvgDeleteFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DeleteFill.e63fd7f6.svg";
export { ForwardRef as ReactComponent };